// Enums
export enum ReservationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export enum RecurrencePattern {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
}

// Interfaces
export interface ReservableAsset {
  id: number;
  name: string;
  type: string; // Dynamic string (not enum) - admin can add new types
  category?: string; // Dynamic string - admin can add new categories
  description?: string;
  expirationDate?: string; // ISO date string
  isActive: boolean;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
  createdById: number;
  updatedById: number;
}

export interface Reservation {
  id: number;
  assetId: number;
  assetName: string;
  assetType: string; // Now a string, not enum
  employeeId: number;
  employeeName: string;
  reservationDate: string;
  startTime?: string;
  endTime?: string;
  isAllDay: boolean;
  purpose?: string;
  status: ReservationStatus;
  approvedById?: number;
  approvedByName?: string;
  approvedAt?: string;
  rejectionReason?: string;
  cancellationReason?: string;
  recurrenceGroupId?: string;
  continuousGroupId?: string;
  // For continuous (multi-day) reservations - the overall span
  continuousStartDate?: string;
  continuousStartTime?: string;
  continuousEndDate?: string;
  continuousEndTime?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateReservationRequest {
  assetId: number;
  startDate: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  isAllDay: boolean;
  purpose?: string;
  timezone: string;
}

export interface CreateRecurringReservationRequest {
  assetId: number;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  isAllDay: boolean;
  purpose?: string;
  pattern: RecurrencePattern; // Backend uses 'pattern' not 'recurrencePattern'
  daysOfWeek?: string[]; // For WEEKLY pattern: ['MONDAY', 'TUESDAY', etc.]
  timezone: string;
}

export interface ReservationActionDto {
  action: "APPROVE" | "REJECT" | "CANCEL";
  reason?: string;
}

export interface AssetStatistics {
  total: number;
  active: number;
}

// Request for creating/updating assets
export interface CreateAssetRequest {
  name: string;
  type: string;
  category?: string;
  description?: string;
  expirationDate?: string;
  isActive?: boolean;
  metadata?: Record<string, any>;
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}
